export class SMilesManagerVersion
{
    version: string;
    name: string;
    summary: string;
    descriptionPlainText: string;
    descriptionHtmlText: string;
    releaseDate: string;
}

export class SmilesManagerVersionHistory {
    history: SMilesManagerVersion[];
    currentVersion: SMilesManagerVersion;
}

export const SMM_VER_DATA:SmilesManagerVersionHistory = {
    currentVersion: {
        version: "2026.7.1",
        //Release Enamel  Release Crown  Release Zircon  Release Composite  Release Occlusal  Release Radiant  Release Lumina  Release Ortho  Release Implant
        name: "Release Apex",
        summary: "Unificare fisa pacient",
        descriptionPlainText: "Actualizarea Smiles Manager aduce îmbunătățiri importante pentru eficiența clinicii și o experiență mai fluidă:\n" +
            "\n" +
            "Centralizarea informației într-o nouă fișă de pacient, bine structurată, care oferă informațiile necesare cu o singură privire.\n" +
            "\n" +
            "Secțiunea planului de tratament a fost îmbunătățită pentru o utilizare mai facilă.\n" +
            "\n" +
            "Alte îmbunătățiri de performanță și securitate.\n" +
            "\n" +
            "Remediere defecte.\n" +
            "\n" +
            "Un pas înainte pentru o clinică mai organizată și un flux de lucru mai eficient.",
        descriptionHtmlText: "<p>Actualizarea Smiles Manager aduce îmbunătățiri importante pentru eficiența clinicii și o experiență mai fluidă:</p>\n" +
            "\n" +
            "<ul>\n" +
            "  <li>Centralizarea informației <strong>într-o nouă fișă de pacient</strong>, bine structurată, care oferă informațiile necesare cu o singură privire.</li>" +
            "  <li><strong>Secțiunea planului de tratament</strong> a fost îmbunătățită pentru o utilizare mai facilă.</li>" +
            "  <li><strong>Alte îmbunătățiri</strong> de performanță și securitate.</li>" +
            "</ul>\n" +
            "\n" +
            "<p>Un pas înainte pentru o clinică mai organizată și un flux de lucru mai eficient.</p>",
        releaseDate: "25 Jul 2026"
    },
    history: [
        {
            version: "2026.5",
            //Release Enamel  Release Crown  Release Zircon  Release Composite  Release Occlusal  Release Radiant  Release Lumina  Release Ortho  Release Implant
            name: "Release Apex",
            summary: "Suport financiar integrat in fisa pacient",
            descriptionPlainText: "Actualizarea Smiles Manager aduce îmbunătățiri importante pentru eficiența clinicii și o experiență mai fluidă:\n" +
                "\n" +
                "Suport financiar complet în fișa pacientului, cu plăți parțiale, discounturi, avans, datorii și balanță actualizată în timp real.\n" +
                "\n" +
                "Optimizări vizuale, în special pentru dispozitive mobile, pentru o navigare mai clară și rapidă.\n" +
                "\n" +
                "Corecturi de erori și un sistem de gestionare a erorilor mai robust, pentru stabilitate crescută.\n" +
                "\n" +
                "Experiență îmbunătățită pentru front desk, cu procese mai rapide și mai intuitive.\n" +
                "\n" +
                "Un pas înainte pentru o clinică mai organizată și un flux de lucru mai eficient.",
            descriptionHtmlText: "<p>Actualizarea Smiles Manager aduce îmbunătățiri importante pentru eficiența clinicii și o experiență mai fluidă:</p>\n" +
                "\n" +
                "<ul>\n" +
                "  <li><strong>Suport financiar complet în fișa pacientului</strong>, cu plăți parțiale, discounturi, avans, datorii și balanță actualizată în timp real.</li>\n" +
                "  <li><strong>Optimizări vizuale</strong>, în special pentru dispozitive mobile, pentru o navigare mai clară și rapidă.</li>\n" +
                "  <li><strong>Corecturi de erori și un sistem de gestionare a erorilor mai robust</strong>, pentru stabilitate crescută.</li>\n" +
                "  <li><strong>Experiență îmbunătățită pentru front desk</strong>, cu procese mai rapide și mai intuitive.</li>\n" +
                "</ul>\n" +
                "\n" +
                "<p>Un pas înainte pentru o clinică mai organizată și un flux de lucru mai eficient.</p>",
            releaseDate: "31 May 2026"
        }
    ]
}
